import React from "react";
import { Grid, Typography } from "@material-ui/core";

export default () => {
  return (
    <Grid container justify="center">
      <Grid item xs={12}>
        <Grid container justify="center">
          <Typography variant="h3" color="secondary">
            Home Page
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
